import { useState } from 'react';
import { API_BASE_URL } from 'utils/constants';
import { getCurrentUserData } from 'utils/helper';
import { api } from '../utils/axios';

const useRequest = ({ method, url, headers, body: data, onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const doRequest = async (overrideOptions) => {
    try {
      setLoading(true);
      const { apiKey } = await getCurrentUserData();

      const axiosConfig = {
        method,
        data,
        ...overrideOptions,
        url: `${API_BASE_URL}${overrideOptions?.url || url}`,
      };

      axiosConfig.headers = {
        ...overrideOptions?.headers,
        'x-api-key': apiKey,
        ...headers,
      };

      if (overrideOptions?.body) {
        axiosConfig.data = overrideOptions.body;
      }

      const response = await api(axiosConfig, axiosConfig?.headers);

      // if (url.indexOf('/v1/') < 0) {
      //   response = response?.data;
      // }

      // console.log({ response });

      if (response.success === false) {
        console.log('Error found!');
        if (onError) {
          onError(response);
        }
      } else if (onSuccess) {
        onSuccess(response);
      }

      return response;
    } catch (err) {
      console.log({ err });
      const { response, message } = err;

      if (response) {
        setError(response);
        if (onError) {
          onError(response);
        }
      } else {
        setError({ message });
        if (onError) {
          onError({ message });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return [doRequest, { loading, error }];
};

export default useRequest;
